export default [

     {
          path: '/risk-department-management',
          name: 'RiskDepartmentManagement',
          component: () => import("@/views/Page/RiskDepartmentManagement/RiskDepartmentManagement.vue"),
           meta: {
               title: 'RiskDepartmentManagement',
               permission: 'RiskDepartmentManagement.show',
          },
     }
];